var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/SubmitButton/SubmitButton.tsx";
import { Button } from '@gmini/ui-kit';
import { IconSpinner, IconSpinnerWrapper, SubmitButtonText } from "./SubmitButton.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SubmitButton = function SubmitButton(_ref) {
  var onClick = _ref.onClick,
      disabled = _ref.disabled,
      loading = _ref.loading;
  return /*#__PURE__*/_jsxs(Button, {
    disabled: disabled || loading,
    size: "regular",
    onClick: onClick,
    color: "info",
    children: [loading && /*#__PURE__*/_jsx(IconSpinnerWrapper, {
      children: /*#__PURE__*/_jsx(IconSpinner, {
        size: 20
      })
    }), /*#__PURE__*/_jsx(SubmitButtonText, {
      hideText: loading,
      children: "\u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
    })]
  });
};